import Box from "ds/components/Box";
import SpacePath from "components/SpacePath";

import { CellComponentProps } from "../types";

type IdpGroupRolesListItemGrantedAtCellProps = CellComponentProps;

const IdpGroupRolesListItemGrantedAtCell = ({
  roleBinding,
}: IdpGroupRolesListItemGrantedAtCellProps) => {
  return (
    <Box align="center" fullWidth>
      <SpacePath spaceId={roleBinding.space.id} fallbackName={roleBinding.space.name} />
    </Box>
  );
};

export default IdpGroupRolesListItemGrantedAtCell;
